import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const NewApplicationOfficer = MatxLoadable({
    loader: () =>
        import ("./NewApplicationOfficer")
})
const AllNewApplicationOfficer = MatxLoadable({
    loader: () =>
        import ("./AllNewApplicationOfficer")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const NewApplicationOfficerRoutes = [
    {
        path: "/new_application_officer",
        component: AllNewApplicationOfficer,
        // settings
    },

];

export default NewApplicationOfficerRoutes;